const messages = {
  title: 'Ups! Zašto ste ovdje?',
  description:
    'Jako nam je žao zbog neugodnosti. Čini se da pokušavate\n' +
    'pristupiti stranici koja je ili obrisana ili nikada nije postojala.',
  backHomeButton: 'Natrag na nadzornu ploču'
}

export default {
  messages
}
